
import { defineComponent, PropType } from 'vue'
import { RunReport, RunReportGrade } from '~/types/types'

interface DimensionConfig {
  key: string
  label: string
  icon: string

  issuesCount: number
  grade: RunReportGrade
}

const DIMENSION_LABELS: Record<string, string> = {
  security: 'Security',
  reliability: 'Reliability',
  complexity: 'Complexity',
  hygiene: 'Hygiene',
  coverage: 'Coverage'
}

const DIMENSION_ICONS: Record<string, string> = {
  security: 'security',
  reliability: 'bug-risk',
  complexity: 'blocks-1',
  hygiene: 'style',
  coverage: 'coverage'
}

export default defineComponent({
  name: 'ReportCardDetail',
  props: {
    reportCard: {
      type: Object as PropType<RunReport>,
      required: true
    }
  },
  computed: {
    dimensions(): DimensionConfig[] {
      const dimensionKeys = ['security', 'reliability', 'complexity', 'hygiene', 'coverage']
      return dimensionKeys
        .filter((key) => {
          const dim = this.reportCard[key as keyof RunReport]
          return dim && typeof dim === 'object' && 'grade' in dim
        })
        .map((key) => {
          const dim = this.reportCard[key as keyof RunReport] as {
            grade: RunReportGrade
            issuesCount?: number
          }
          return {
            key,
            label: DIMENSION_LABELS[key],
            icon: DIMENSION_ICONS[key],
            issuesCount: dim.issuesCount ?? 0,
            grade: dim.grade
          }
        })
    },
    focusAreaLabel(): string {
      const dim = this.reportCard.focusArea?.dimension
      if (!dim) return ''
      return DIMENSION_LABELS[dim.toLowerCase()] ?? dim
    }
  }
})
